import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import {
  loadByDepartureAirportCarrierAndDate,
  loadByArrivingAirportCarrierAndDate,
  loadByRouteCarrierAndDate,
} from './redux/actions';
import FlightTrackerMultiFlightResults from './children/FlightTrackerMultiFlightResults/FlightTrackerMultiFlightResults';
import componentBase from '../../src/lib/component-base';
import { addMetaCanonical } from '../../shared/lib/meta-tags';

@connect(state => ({
  flights: state.MultiFlightTracker.data,
  error: state.MultiFlightTracker.error,
  loading: state.MultiFlightTracker.loading,
  loaded: state.MultiFlightTracker.loaded,
  pageIndex: state.MultiFlightTracker.pageIndex,
  searchUrl: state.MultiFlightTracker.searchUrl,
}))
@componentBase('MultiFlight')
export default class MultiFlight extends React.Component {
  static propTypes = {
    flights: PropTypes.object,
    error: PropTypes.object,
    loaded: PropTypes.bool,
    loading: PropTypes.bool,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    location: PropTypes.object,
    searchUrl: PropTypes.string,
  };

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { arrivalAirportCode, departureAirportCode } = match.params;

    if (arrivalAirportCode && departureAirportCode) {
      return dispatch(loadByRouteCarrierAndDate(match.params));
    }

    if (arrivalAirportCode) {
      return dispatch(loadByArrivingAirportCarrierAndDate(match.params));
    }

    return dispatch(loadByDepartureAirportCarrierAndDate(match.params));
  }

  componentWillUpdate(nextProps) {
    const {
      dispatch, error, flights, loaded,
    } = nextProps;
    if (!this.props.error && nextProps.error) {
      dispatch(push(`/flight-tracker/search/advanced?error=${error.code}`));
    } else if (
      loaded &&
      (!flights || !flights.flights ||
        (flights.flights && flights.flights.length === 0))
    ) {
      dispatch(push('/flight-tracker/search/advanced?error=FLIGHTS_LOAD_ERROR2'));
    }
  }

  meta = () => (addMetaCanonical({ title: 'Flight Tracker' }, this.props.location.pathname));

  render() {
    if (this.props.loading) {
      return (
        <div />
      );
    }
    return (
      <div className='container'>
        <Helmet {...this.meta()} />
        <FlightTrackerMultiFlightResults
          {...this.props}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/MultiFlight/container.js